module.exports = __webpack_public_path__ + "media/hoekpunten.0d5f98ab.mp4";